import React from "react";
import { CATEGORY_INTRO } from "../lib/categoryIntro";

export const CategoryIntro = ({ slug, catName, city, total, districts }) => {
  const base = CATEGORY_INTRO[slug];
  const top = [...(districts || [])].filter(([d, n]) => d && n > 0).sort((a, b) => b[1] - a[1]).slice(0, 6).map(([d]) => d);
  if (!base && !total) return null;
  return (
    <section className="max-w-7xl mx-auto px-5 pb-14" data-testid="category-intro">
      <div className="bg-white rounded-2xl border border-[#F0DDE0] p-6 md:p-8">
        <h2 className="font-display text-base md:text-lg font-semibold text-[#2A2224]">
          {city ? `${city} ${catName} hakkında` : `${catName} hakkında`}
        </h2>
        {total > 0 && (
          <p className="text-sm text-[#5b4d4f] mt-3 leading-relaxed">
            DüğünSenin'de {city ? `${city} ilinde ` : "Türkiye genelinde "}{catName} kategorisinde {total.toLocaleString("tr-TR")} işletme listeleniyor.
            {top.length > 0 && ` En çok kayıt bulunan ilçeler: ${top.join(", ")}.`} Firmaların fotoğraflarını, özelliklerini ve fiyat bilgilerini inceleyip ücretsiz teklif isteyebilirsiniz.
          </p>
        )}
        {base && <p className="text-sm text-[#5b4d4f] mt-3 leading-relaxed">{base}</p>}
      </div>
    </section>
  );
};
